import { render, staticRenderFns } from "./SidebarRelatedAssets.vue?vue&type=template&id=27aaf114&scoped=true"
import script from "./SidebarRelatedAssets.vue?vue&type=script&lang=js"
export * from "./SidebarRelatedAssets.vue?vue&type=script&lang=js"
import style0 from "./SidebarRelatedAssets.vue?vue&type=style&index=0&id=27aaf114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aaf114",
  null
  
)

export default component.exports